import React from 'react';
import { Copy } from '@honda-canada/design-system-react';

const NotImplemented = () => <Copy />;

export default NotImplemented;
